import React from 'react';

import { Skeleton } from '@/components/shadcn/ui/skeleton';
import { TableHead, TableHeader, TableRow } from '@/components/shadcn/ui/table';

const SwapTableHeaderSkeleton: React.FC = () => {
  return (
    <TableHeader className="[&_tr]:border-muted-foreground/20">
      <TableRow className="h-9">
        <TableHead className="w-8">
          <Skeleton className="h-6" variant="background" />
        </TableHead>
        <TableHead className="w-16">
          <Skeleton className="h-6" variant="background" />
        </TableHead>
        <TableHead className="w-20">
          <Skeleton className="h-6" variant="background" />
        </TableHead>
        <TableHead className="w-20">
          <Skeleton className="h-6" variant="background" />
        </TableHead>
        <TableHead className="w-20">
          <Skeleton className="h-6" variant="background" />
        </TableHead>
        <TableHead className="w-14">
          <Skeleton className="h-6" variant="background" />
        </TableHead>
        <TableHead className="w-14">
          <Skeleton className="h-6" variant="background" />
        </TableHead>
        <TableHead className="w-14">
          <Skeleton className="h-6" variant="background" />
        </TableHead>
        <TableHead className="w-20">
          <Skeleton className="h-6" variant="background" />
        </TableHead>
        <TableHead className="w-24">
          <Skeleton className="h-6" variant="background" />
        </TableHead>
        <TableHead className="w-14">
          <Skeleton className="h-6" variant="background" />
        </TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default SwapTableHeaderSkeleton;
